// 베스트 아이템 첫 줄

let bestItem = [
    {
        
        imgUrl:"/img/best_item/best1.jpg",
        imgUrl2:"/img/best_item/best1_1.jpg",
        title: "베이직 퍼포먼스 카라 티셔츠 WHITE (MAN)",
        code:"M3321PTS05WHT",
        price:"279,000원",


    }, {
        
        imgUrl:"/img/best_item/best2.jpg",
        imgUrl2:"/img/best_item/best2_2.jpg",
        title: "36 버킷 폴로 티셔츠 GREEN (MAN)",
        code:"M3321PTS25GRN",
        price:"259,000원"


    } , {
    
        imgUrl:"/img/best_item/best3.jpg",
        imgUrl2:"/img/best_item/best3_3.jpg",
        title: "버킷 폴로 포인트 티셔츠 SKY BLUE (MAN)",
        code:"M3221PTS04SBL",
        price:"259,000원"


    }, {
        
        imgUrl:"/img/best_item/best4.jpg",
        imgUrl2:"/img/best_item/best1_4.jpg",
        title: "말본 스크립트 라운드 티셔츠 BEIGE (UNISEX)",
        code:"M3223PRS06BEI",
        price:"129,000원"

    }]

    export default bestItem;